module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Regular.7ff6b59.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Regular/SFProDisplay-Regular.woff
// module id = mBd3
// module chunks = 17